import React from "react";
import { useNavigate } from "react-router-dom";
import './BrandSelect.css';
import agroLogo from "../assets/agro.png";
import martLogo from "../assets/mart.png";

const BrandSelect = () => {
  const navigate = useNavigate();

  const selectBrand = (brand) => {
    localStorage.setItem("brand", brand);
  if (brand === "atr-agro-mart") {
      navigate("/agro"); // This opens your new dashboard
    } else {
      navigate("/mart"); // This will be for your other brand
    }
  };

  return (
  <div className="gateway-container">
    <div className="split-background">
      <div className="split-side agro-side"></div>
      <div className="split-side mart-side"></div>
    </div>

    <main className="brand-overlay">
      <div className="glass-brand-card">
        <h1 className="main-title">Welcome to ATR Ecosystem</h1>
        <p className="sub-title">Select your destination to continue</p>
        
        <div className="brand-options">
          <div className="brand-item" onClick={() => selectBrand("atr-agro-mart")}>
            <div className="logo-wrapper">
              <img src={agroLogo} alt="Agro Logo" />
            </div>
            <button className="btn-agro">ATR Agro Mart</button>
          </div>

          <div className="divider"></div>

          <div className="brand-item" onClick={() => selectBrand("atrmart")}>
            <div className="logo-wrapper">
              <img src={martLogo} alt="Mart Logo" />
            </div>
            <button className="btn-mart">ATR Mart</button>
          </div>
        </div>
      </div>
    </main>

<footer className="footer-section">
  <div className="footer-container">
    <div className="footer-main-grid">
      
      {/* 1. BRAND DESCRIPTION COLUMN */}
      <div className="footer-col brand-info">
        <h2 className="footer-logo">ATR Mart</h2>
        <p className="footer-desc">
          ATR Mart is one of the largest and most innovative Indian full-stack AgriTech platforms 
          dedicated to revolutionizing the agricultural industry in India. We provide a wide range 
          of solutions to farmers, helping them optimize their agricultural practices and increase productivity.
        </p>
        <div className="social-links">
          <a href="#"><i className="fab fa-instagram"></i></a>
          <a href="#"><i className="fab fa-facebook"></i></a>
          <a href="#"><i className="fab fa-youtube"></i></a>
          <a href="#"><i className="fab fa-twitter"></i></a>
          <a href="#"><i className="fab fa-linkedin"></i></a>
        </div>
      </div>

      {/* 2. QUICK LINKS COLUMN */}
      <div className="footer-col">
        <h4>Quick Links</h4>
        <ul>
          <li><a href="/about-us">About Us</a></li>
          <li><a href="/about-atr-group">About ATR Group</a></li>
          <li><a href="/privacy">Privacy Policy</a></li>
          <li><a href="/terms">Terms & Conditions</a></li>
          <li><a href="/shipping-policy">Shipping Policy</a></li>
          <li><a href="/return-policy">Return Policy</a></li>
          <li><a href="/refund-cancellation">Refund & Cancellation</a></li>
        </ul>
      </div>

      {/* 3. CONTACT COLUMN */}
      <div className="footer-col">
        <h4>Contact Us</h4>
        <div className="contact-item">
          <p className="contact-label">Email Support:</p>
          <a href="mailto:support@atrmart.in" className="contact-link">
            <i className="fas fa-envelope"></i> support@atrmart.in
          </a>
        </div>
        <div className="contact-item">
          <p className="contact-label">WhatsApp Support:</p>
          <a href="https://wa.me/919344453444" target="_blank" rel="noreferrer" className="contact-link whatsapp-btn">
            <i className="fab fa-whatsapp"></i> +91 93444 53444
          </a>
        </div>
        <div className="office-info">
          <p><strong>Corporate Office:</strong></p>
          <p>ATR Solar & Agro Pvt Ltd</p>
          <p>Madurai, Tamil Nadu, India</p>
        </div>
      </div>

    </div>

    <div className="footer-bottom-bar">
      <p>&copy; 2026 ATR Mart. All Rights Reserved.</p>
    </div>
  </div>
</footer>
  </div>
);
};

export default BrandSelect;